import React from 'react';
import { storiesOf } from '@storybook/react';
import FilersResultRow from './FilersResultRow';
import { RowHeader } from '../EntriesResults';

storiesOf('Advanced Search/Result Rows', module)
  .add('Filers', () => (
    <div className="result-item">
      <RowHeader row={row} />
      <div className="result-item-body">
        <FilersResultRow row={row} />
      </div>
    </div>
  ));

const row = {
  case:{},
  case_assets: "Unknown",
  case_chapter: 11,
  case_court: "nysbke",
  case_date_filed: "03/10/2014",
  case_judge_name: "Martin Glenn",
  case_liabilities: "Unknown",
  case_naics_code: null,
  case_nature_of_suit_code: null,
  case_no: "1:14-bk-10557",
  case_title: "Sbarro LLC",
  case_type: "bk",
  case_uuid: "nysbke_247775",
  date_added: "03/28/2014",
  date_filed: "08/29/2019",
  date_terminated: null,
  document_type: "filers",
  highlighted: {name: true},
  id: "filers:nysbke_247775--Official Committee of Unsecured Creditors of Sbarro LLC, et al./Creditor Committee",
  index_timestamp: 1567082848,
  join: {name: "documents", parent: "cases:nysbke_247775"},
  modified: "2014-05-01 19:43:54.973514+00",
  name: 'Official Committee of Unsecured Creditors of <span class="highlight">Sbarro</span> LLC, et al.',
  query: "filers",
  type: "Creditor Committee",
};


// WEBPACK FOOTER //
// ./src/components/advancedSearch/results/rows/FilersResultRow.stories.jsx